import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { filterDefined } from "./objects";
export var getNodeCenterOffset = function getNodeCenterOffset(node) {
  if (_typeof(node) !== 'object' || node === null || !('getBoundingClientRect' in node)) return null;
  var _node$getBoundingClie = node.getBoundingClientRect(),
    width = _node$getBoundingClie.width,
    left = _node$getBoundingClie.left;
  return left + width / 2;
};
export var getNodeLeftOffset = function getNodeLeftOffset(node) {
  if (_typeof(node) !== 'object' || node === null || !('getBoundingClientRect' in node)) return null;
  var _node$getBoundingClie2 = node.getBoundingClientRect(),
    left = _node$getBoundingClie2.left;
  return left;
};
var defaultTriggerOptions = {
  eventInterface: 'Event',
  bubbles: true,
  cancelable: true
};
export var triggerCustomEvent = function triggerCustomEvent(domElement, eventName) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _defaultTriggerOption = _objectSpread(_objectSpread({}, defaultTriggerOptions), filterDefined(options)),
    eventInterface = _defaultTriggerOption.eventInterface,
    bubbles = _defaultTriggerOption.bubbles,
    cancelable = _defaultTriggerOption.cancelable;
  var event = document.createEvent(eventInterface);
  event.initEvent(eventName, bubbles, cancelable);
  event.eventName = eventName;
  domElement.dispatchEvent(event);
};
export var triggerFormSubmit = function triggerFormSubmit(form) {
  if (!form) {
    return;
  }
  var handleFormSubmit = function handleFormSubmit(event) {
    if (!event.defaultPrevented) {
      form.submit();
    }
  };
  form.addEventListener('submit', handleFormSubmit);
  triggerCustomEvent(form, 'submit');
  form.removeEventListener('submit', handleFormSubmit);
};

/**
 * Takes color in any web format: named, rgb, rgba, hex, short hex
 * Returns array of [r, g, b, a]
 */
export var colorToRGBA = function colorToRGBA(webColor) {
  var cvs = document.createElement('canvas');
  cvs.height = 1;
  cvs.width = 1;
  var ctx = cvs.getContext('2d');
  ctx.fillStyle = webColor;
  ctx.fillRect(0, 0, 1, 1);
  return ctx.getImageData(0, 0, 1, 1).data;
};

/**
 * Takes color in any web format: named, rgb, rgba, hex, short hex
 * Returns black or white, that makes better contrast to given color
 */
export var contrastBlackOrWhite = function contrastBlackOrWhite(webColor) {
  if (!webColor) {
    return 'black';
  }
  var _colorToRGBA = colorToRGBA(webColor),
    _colorToRGBA2 = _slicedToArray(_colorToRGBA, 3),
    red = _colorToRGBA2[0],
    green = _colorToRGBA2[1],
    blue = _colorToRGBA2[2];
  return red * 0.299 + green * 0.587 + blue * 0.114 > 186 ? 'black' : 'white';
};
export var contrastBgStyles = function contrastBgStyles(backgroundColor) {
  return {
    backgroundColor: backgroundColor,
    color: contrastBlackOrWhite(backgroundColor)
  };
};

/**
 * Takes name attribute of a node as an argument and scrolls to the first found node with given name
 */

export var scrollTo = function scrollTo(name) {
  var _document, _document$getElements, _element$scrollIntoVi;
  var scrollLogicalPosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'start';
  var element = (_document = document) === null || _document === void 0 ? void 0 : (_document$getElements = _document.getElementsByName(name)) === null || _document$getElements === void 0 ? void 0 : _document$getElements.item(0);
  element === null || element === void 0 ? void 0 : (_element$scrollIntoVi = element.scrollIntoView) === null || _element$scrollIntoVi === void 0 ? void 0 : _element$scrollIntoVi.call(element, {
    block: scrollLogicalPosition,
    behavior: 'smooth'
  });
};

/**
 * Проверка на наличие элемента на странице
 * @returns {boolean}
 */
export var isInPage = function isInPage(node) {
  return node === document.body ? false : document.body.contains(node);
};

/**
 * Прокрутка документа вверх до указанных координат
 */
export var scrollToTop = function scrollToTop() {
  var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  window.scrollTo({
    top: top,
    behavior: 'smooth'
  });
};